var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}
__name(_typeof, "_typeof");
var _excluded = ["imgProps", "lazyload", "background"], _excluded2 = ["style"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
__name(ownKeys, "ownKeys");
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
__name(_objectSpread, "_objectSpread");
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
__name(_defineProperty, "_defineProperty");
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o, r, i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
__name(_objectWithoutProperties, "_objectWithoutProperties");
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
__name(_objectWithoutPropertiesLoose, "_objectWithoutPropertiesLoose");
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
__name(_classCallCheck, "_classCallCheck");
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || false, o.configurable = true, "value" in o && (o.writable = true), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
__name(_defineProperties, "_defineProperties");
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: false }), e;
}
__name(_createClass, "_createClass");
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
__name(_toPropertyKey, "_toPropertyKey");
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
__name(_toPrimitive, "_toPrimitive");
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
__name(_callSuper, "_callSuper");
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
__name(_possibleConstructorReturn, "_possibleConstructorReturn");
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
__name(_assertThisInitialized, "_assertThisInitialized");
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = /* @__PURE__ */ __name(function _isNativeReflectConstruct2() {
    return !!t;
  }, "_isNativeReflectConstruct"))();
}
__name(_isNativeReflectConstruct, "_isNativeReflectConstruct");
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t2) {
    return t2.__proto__ || Object.getPrototypeOf(t2);
  }, _getPrototypeOf(t);
}
__name(_getPrototypeOf, "_getPrototypeOf");
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: true, configurable: true } }), Object.defineProperty(t, "prototype", { writable: false }), e && _setPrototypeOf(t, e);
}
__name(_inherits, "_inherits");
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t2, e2) {
    return t2.__proto__ = e2, t2;
  }, _setPrototypeOf(t, e);
}
__name(_setPrototypeOf, "_setPrototypeOf");
import classNames from "classnames";
import React, { Component } from "react";
import { BasePlaceholder } from "./Base";
import { imgPlaceholderCls, imgPlaceholderBoxCls, imgPlaceholderLoadingCls, defaultImgPlaceholderBackground } from "./Image.less";
function ImagePlaceholder(DecoratedPicture) {
  return /* @__PURE__ */ function(_Component) {
    function _class(props) {
      var _this;
      _classCallCheck(this, _class);
      _this = _callSuper(this, _class, [props]);
      _this.bindMethods();
      var image = _this.props.image;
      _this.state = {
        calcPaddingTop: image && image.width && image.height ? 100 / (image.width / image.height) : 0
      };
      return _this;
    }
    __name(_class, "_class");
    _inherits(_class, _Component);
    return _createClass(_class, [{
      key: "componentDidMount",
      value: /* @__PURE__ */ __name(function componentDidMount() {
        var calcPaddingTop = this.state.calcPaddingTop;
        if (calcPaddingTop && calcPaddingTop > 0) {
          if (this.imgRef && this.imgRef.naturalWidth > 0 && this.imgRef.naturalHeight > 0) {
            this.setState({
              calcPaddingTop: 0
            });
          }
        }
      }, "componentDidMount")
      /**
       * getDerivedStateFromProps
       *
       * @param {Props} props
       * @param {State} state
       * @returns {?State}
       */
    }, {
      key: "handleLoad",
      value: (
        /**
         * handleLoad
         */
        /* @__PURE__ */ __name(function handleLoad(e) {
          var imgProps = this.props.imgProps;
          this.setState({
            calcPaddingTop: 0
          });
          imgProps && imgProps.onLoad && typeof imgProps.onLoad === "function" && imgProps.onLoad(e);
        }, "handleLoad")
      )
      /**
       * setImgRef
       *
       * @param {Object} img
       */
    }, {
      key: "setImgRef",
      value: /* @__PURE__ */ __name(function setImgRef(img) {
        this.imgRef = img;
      }, "setImgRef")
      /**
       * bindMethods
       */
    }, {
      key: "bindMethods",
      value: /* @__PURE__ */ __name(function bindMethods() {
        this.handleLoad = this.handleLoad.bind(this);
        this.setImgRef = this.setImgRef.bind(this);
      }, "bindMethods")
      /**
       * render
       */
    }, {
      key: "render",
      value: /* @__PURE__ */ __name(function render() {
        var _this$props = this.props, imgProps = _this$props.imgProps, _this$props$lazyload = _this$props.lazyload, lazyload = _this$props$lazyload === void 0 ? {} : _this$props$lazyload, _this$props$backgroun = _this$props.background, background = _this$props$backgroun === void 0 ? true : _this$props$backgroun, restProps = _objectWithoutProperties(_this$props, _excluded);
        var calcPaddingTop = this.state.calcPaddingTop;
        var paddingTop = calcPaddingTop ? "".concat(calcPaddingTop, "%") : null;
        var combinedImgProps = null;
        var absoluteStyle = paddingTop ? {
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%"
        } : null;
        if (imgProps) {
          var style = imgProps.style, restImgProps = _objectWithoutProperties(imgProps, _excluded2);
          combinedImgProps = _objectSpread(_objectSpread({}, restImgProps), {}, {
            onLoad: this.handleLoad,
            style: _objectSpread(_objectSpread({}, style), absoluteStyle),
            ref: this.setImgRef
          });
        } else {
          combinedImgProps = {
            onLoad: this.handleLoad,
            style: absoluteStyle,
            ref: this.setImgRef
          };
        }
        return /* @__PURE__ */ React.createElement("span", {
          className: classNames(imgPlaceholderCls, paddingTop && imgPlaceholderLoadingCls)
        }, paddingTop ? /* @__PURE__ */ React.createElement("span", {
          className: imgPlaceholderBoxCls,
          style: _objectSpread(_objectSpread({}, background ? {
            background: background === true || background === "default" ? defaultImgPlaceholderBackground : background
          } : {}), {}, {
            paddingTop
          })
        }) : null, /* @__PURE__ */ React.createElement(DecoratedPicture, _extends({}, restProps, {
          imgProps: combinedImgProps,
          lazyload: lazyload ? _objectSpread({
            once: true,
            height: "auto",
            offset: 200,
            placeholder: /* @__PURE__ */ React.createElement(BasePlaceholder, {
              style: _objectSpread(_objectSpread({}, absoluteStyle), {}, {
                paddingTop
              })
            })
          }, lazyload.config || {}) : null
        })));
      }, "render")
    }], [{
      key: "getDerivedStateFromProps",
      value: /* @__PURE__ */ __name(function getDerivedStateFromProps(props, state) {
        if (state.calcPaddingTop === 0) {
          return null;
        }
        var image = props.image;
        var updatedPaddingTop = image && image.width && image.height ? 100 / (image.width / image.height) : 0;
        return updatedPaddingTop !== state.calcPaddingTop ? {
          calcPaddingTop: updatedPaddingTop
        } : null;
      }, "getDerivedStateFromProps")
    }]);
  }(Component);
}
__name(ImagePlaceholder, "ImagePlaceholder");
export {
  ImagePlaceholder
};
